import React, { useState, forwardRef } from 'react';
import '../../styles/sections/sidebars/SidebarMail.css';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert, { type AlertProps } from '@mui/material/Alert';
import { Fade } from 'react-awesome-reveal';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SidebarMail: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText('oleg@glotov.com');
    setOpen(true);
  };

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <div className="navAreaMail">
      <div className="mail">
        <Fade direction="right" delay={2000}>
          <p className="linkMail" onClick={handleClick}>
            oleg@glotov.com
          </p>
        </Fade>
        <Snackbar
          className="snackbar"
          open={open}
          autoHideDuration={3000}
          onClose={handleClose}
          message="Email saved to clipboard"
          action={action}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            onClose={handleClose}
            severity="info"
            sx={{ width: '100%', color: 'black', backgroundColor: 'white' }}
          >
            Email copied to clipboard!
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};
